<mat-form-field appearance="outline">
  <input
    matInput
    class="pb-[0.1rem]"
    [formControl]="control"
    [name]="'search'"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    [panelWidth]="'fit'"
    #auto="matAutocomplete"
    [displayWith]="displayWith"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option
      *ngFor="let search of searchList"
      [value]="search"
      class="text-sm"
    >
      {{ search.displayName }}
    </mat-option>
    <mat-option
      *ngIf="!isSearching && control.value && searchList && !exactMatch"
      [value]="control.value"
      [id]="ADD_NEW_OPTION"
      class="text-sm"
    >
      Add new {{ addNewText + ' "' + control.value + '"' }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
